var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","block":"","small":""},on:{"click":_vm.saveAsFile}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" Salva ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }